/**
 * @param {string} id
 * @returns string
 */
const convertIdToAbsoluteUrn = id => `urn:dm:schemas:${id}`
/**
 *
 * @param {string} urn
 * @returns {boolean}
 */
const isAbsoluteUrn = (/** @type {string} */ urn) => urn.startsWith('urn:')

module.exports = {
    convertIdToAbsoluteUrn,
    isAbsoluteUrn
}
